import { useRef, useEffect } from "react";
const useFocus = () => {
  const htmlElRef = useRef(null);
  const setFocus = (keepFocus = true) => {
    if (!(htmlElRef == null ? void 0 : htmlElRef.current)) {
      return;
    }
    if (keepFocus) {
      htmlElRef.current.focus();
    } else {
      htmlElRef.current.blur();
    }
  };
  return [htmlElRef, setFocus];
};
const useKeyboardListener = (elementRef, onBlur, keyActions, deps) => {
  const handleKeyPress = (event) => {
    if (document.activeElement !== elementRef.current) {
      return;
    }
    if (event.key === "Escape") {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      onBlur();
    }
    keyActions.forEach((keyAction) => {
      if (event.key === (keyAction == null ? void 0 : keyAction.key)) {
        keyAction == null ? void 0 : keyAction.action(event);
      }
    });
  };
  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => document.removeEventListener("keydown", handleKeyPress);
  });
  return handleKeyPress;
};
const useDidUpdateEffect = (fn, inputs, force) => {
  const didMountRef = useRef(false);
  useEffect(() => {
    if (didMountRef.current || didMountRef.current === false && force) {
      if (force) {
        didMountRef.current = true;
      }
      return fn();
    }
    didMountRef.current = true;
    return null;
  }, inputs);
};
const hooks = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useDidUpdateEffect,
  useFocus,
  useKeyboardListener
}, Symbol.toStringTag, { value: "Module" }));
export {
  useFocus as a,
  useDidUpdateEffect as b,
  hooks as h,
  useKeyboardListener as u
};
//# sourceMappingURL=hooks-BlwR7OOF.js.map
